<template>
  <div
    id="dataPoster_workstation"
    :style="{
      '--mixtmt_mixvw': cssDynamicObj.mixvw,
    }"
  >
    <workspace_leftContainer
      v-if="mainLeftHeight"
      :currThemeObj="currThemeObj"
      :axiosBaseUrl="axiosBaseUrl"
      :posterBaseInfor="posterBaseInfor"
      :containerHeight="mainLeftHeight"
      :picSizeArr="currArr_picSizeArr"
      :themeItemData="themeItemData"
    ></workspace_leftContainer>
    <div class="main_right" ref="main_right">
      <span
        class="librayTitle"
        v-text="curr_analysisTypeItem.posterName"
      ></span>
      <span class="selectGourp">
        <!-- <span class="selectTitle" v-text=""></span> -->
        <span class="theme_select">
          <el-select
            v-model="currItem_params.analysisTypeId"
            placeholder="请选择海报主题"
            popper-class="theme_select_popper"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in currArr_analysisTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </span>
      </span>
      <span
        class="editRow_area"
        v-for="editItem in currArr_editListWeb"
        :key="editItem.id"
        :class="editItem.id"
      >
        <span class="editTitle" v-text="editItem.title"></span>
        <span class="editBody">
          <span
            v-for="(inputItem, inputIndex) in editItem.editArr"
            :key="inputIndex"
            class="inputBox"
          >
            <template v-if="inputItem && inputItem.nameArr"></template>
            <span
              class="inputRowText"
              v-for="(text, textIndex) in inputItem.nameArr"
              :key="textIndex"
              v-text="text"
            ></span>
          </span>
        </span>
        <span
          class="editBtn el-icon el-icon-edit-outline"
          @click="editMatchOpt(editItem)"
        ></span>
      </span>
      <span class="selectGourp">
        <span class="selectTitle" v-text="'设计风格'"></span>
        <span class="theme_select">
          <el-select
            v-model="currItem_params.designStyleId"
            placeholder="请选择设计风格"
            popper-class="theme_select_popper"
            :popper-append-to-body="false"
            @change="changeDesignStyle"
          >
            <el-option
              v-for="item in currArr_designStyles"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </span>
      </span>
      <span class="themeArea">
        <themeListSelectOpt
          v-if="findAnalysisItemParams"
          :axiosBaseUrl="currItem_params.urlPrefix"
          :currThemeObj="currThemeObj"
          :currCid="currItem_params.competitionId"
          :currSid="currItem_params.seasonId"
          :findAnalysisItemResData="findAnalysisItemResData"
          :findAnalysisItemParams="findAnalysisItemParams"
          :paramsChangeObj="paramsChangeObj"
          @themeItemRenderDataEvent="themeItemRenderDataEventHandler"
        ></themeListSelectOpt>
        <!-- <img :src="makeBase64" /> -->
      </span>
    </div>
    <div class="dialog_pop">
      <template v-if="isdDrawerOpen_schedule">
        <edit_didEid_pop
          :currThemeObj="currThemeObj"
          :axiosBaseUrl="axiosBaseUrl"
          :currItem_params="currItem_params"
          :seasonArr="currArr_seasons"
          :bigSportsArr="currArr_sports"
          :isOpen="isdDrawerOpen_schedule"
          :allMatchList="allMatchList"
          :selectOptData_origin="selectOptData_origin"
          @changeMatchItemEvent="changeMatchItemEventHandler"
          @closeDoneEvent="closeDoneEventHandler"
          @changeSelectItemEvent="changeSelectItemEventHandler"
        ></edit_didEid_pop>
      </template>
      <template v-if="isdDrawerOpen_competition">
        <edit_cidSid_pop
          :currThemeObj="currThemeObj"
          :axiosBaseUrl="axiosBaseUrl"
          :currItem_params="currItem_params"
          :competitionArr="currArr_competitions"
          :isOpen="isdDrawerOpen_competition"
          @closeDoneEvent="closeDoneEventHandler"
          @saveParamsEvent="saveParamsEventHandler"
        ></edit_cidSid_pop>
      </template>
    </div>
  </div>
</template>
<script>
import ossPutObject from '@/utils/upload_oss.js'

import {
  https_dataPoster_posterDetail,
  https_dataPoster_findAnalysisItemById,
} from '@api/platfrom_dataPoster_api.js'
import { https_sportsEvent_schedule } from '@api/platfrom_compreSportsMeet_api'
import { https_getOssUploadInfor } from '@api/platfrom_base_api.js'
import dataPoster_base_data_mixin from '@mixins/dataPoster_base_data'
import edit_cidSid_pop from './edit_cidSid_pop.vue'
import edit_didEid_pop from './edit_didEid_pop.vue'
import themeListSelectOpt from '@components/platfromBase/dataPoster/poster_themeList/index.vue'

import workspace_leftContainer from '@components/platfromBase/dataPoster/workspace_leftContainer/index.vue'

export default {
  name: 'dataPosterWorkstation',
  mixins: [dataPoster_base_data_mixin],
  components: {
    edit_cidSid_pop,
    edit_didEid_pop,
    themeListSelectOpt,
    workspace_leftContainer,
  },
  props: {
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  data() {
    return {
      curr_analysisTypeItem: {
        analysisTypes: null,
        posterName: '',
        posterId: null,
        haveInput: null,
        posterPicture: null,
      },
      currItem_params: {
        analysisTypeId: '',
        competitionId: '',
        seasonId: '',
        sportsId: '',
        eventId: '',
        date: '',
        designStyleId: '',
        posterAnalysis: {}, //小项对应的分析项id，小项变化则需要重新赋值
        sportType: '',
        urlPrefix: '', //获取主题接口的根路径
      },
      currArr_analysisTypes: [
        // {
        //   id: '11',
        //   name: '测试1',
        // },
        // {
        //   id: '22',
        //   name: '测试2',
        // },
      ],
      currArr_editListWeb: [
        {
          title: '赛事',
          id: 'competition',
          editArr: [
            {
              nameArr: [''],
              valueArr: ['competitionId'],
            },
            {
              nameArr: [''],
              valueArr: ['seasonId'],
            },
          ],
        },
        {
          title: '比赛',
          id: 'schedule',
          editArr: [
            {
              // nameArr: ['比赛日期', '比赛大小项', '比赛对阵'],
              // valueArr: ['did', 'eid', 'dateId', 'mid'],
              nameArr: [],
              valueArr: [],
            },
          ],
        },
      ],
      currArr_competitions: [],
      currArr_seasons: [],
      currArr_sports: [],
      currArr_events: [],
      currArr_dates: [],
      currArr_designStyles: [],
      currArr_picSizeArr: [
        // {
        //   id: '1',
        //   name: '1920*1080',
        // },
        // {
        //   id: '2',
        //   name: '750*1334',
        // },
      ],
      isdDrawerOpen_competition: false, //是否打开编辑赛事弹窗
      isdDrawerOpen_schedule: false, //是否打开编辑比赛弹窗
      findAnalysisItemResData: null, //没处理的主题信息数组
      findAnalysisItemParams: null, //获取主题数据需要的赛事参数
      selectOptData_origin: {
        configArr: [
          {
            type: 'bigSports',
            title: '项目',
            origin_keyVal: ['value', 'name'],
            dataName: 'bigSportsArr',
            selectIndex: 0,
            isFilterable: true, //选择框是否带可搜索功能
          },
          {
            type: 'sportEvents',
            title: '分项',
            origin_keyVal: ['value', 'name'],
            dataName: 'sportEventsArr',
            selectIndex: 0,
            isFilterable: true,
          },
          {
            type: 'matchDate',
            title: '日期',
            origin_keyVal: ['value', 'name'],
            dataName: 'matchDateArr',
            selectIndex: 0,
          },
        ],
        selectOpt_list: [],
      },
      paramsChangeObj: {
        type: 'reset',
        num: 0,
      },
      posterBaseInfor: null,
      mainLeftHeight: 0, //默认值
      themeItemData: null,

      // currItem_workspaceParams: {
      //   curSizeId: '', //目前选中的尺寸 id
      // },
      // imgUrl:
      //   'https://hyper-sports-res.mixtmt.com/app/competition/small/SOG.png',
      // makeBase64: '',

      // dialogItem: null, // 点击【更换素材】时，弹窗的对象

      // showCropperPop: false, // 是否显示裁图弹窗
      // editFile: { url: '' }, // 临时存储截图的对象
      // uploadType: 'uploadImage',
      // jionUrlSymbols: ',', //用来区分多个图片链接的符号 this.item.value: 'url1'||'url1,url2,url3'
      // fileList: [
      //   // 这个是数组，可以存储单张或者多张图片；单张图片向父级返回单张图片字符串地址；多张图片向父级返回多张地址数组.join(this.jionUrlSymbols)的字符串
      //   {
      //     name: '麦克风.jpg',
      //     percentage: 100,
      //     status: 'success', //'location':刚从本地读取文件到浏览器未上传； 'progress':正在向oss上传；'success':已经上传成功
      //     size: 24531,
      //     raw: {},
      //     uid: 1678249363302,
      //     // url: 'https://hyper-sports-res.mixtmt.com/app/competition/small/SOG.png',
      //     url: require(`@src/assets/images/platfrom_mixtmt/loginPage_log.png`),
      //     submitVal: 'hyper/%E9%BA%A6%E5%85%8B%E9%A3%8E.jpg', //不要oss域名的路径
      //     absOssUrl:
      //       'http://mixtmt-images.oss-cn-beijing.aliyuncs.com/hyper/%E9%BA%A6%E5%85%8B%E9%A3%8E.jpg', //oss生产的在线地址
      //     isDraggable: false, //开关：控制是否可以拖拽
      //     className: 'logo',
      //     actState: '',
      //     styleItem: {
      //       left: '30%',
      //       top: 0,
      //     },
      //   },
      // ],
    }
  },
  created() {
    // 上传图片input 唯一id
    // this.uploadDom_id = this.guid('m-upload-file-xxxxxx-4xxx-yxxx')
    // 开启拖拽功能
    // this.draggableGroupRefsName = 'workspace_view'
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  mounted() {
    if (this.$refs.main_right) {
      console.debug('main_right:', this.$refs.main_right.offsetHeight)
      this.$nextTick(() => {
        this.mainLeftHeight = this.$refs.main_right.offsetHeight
      })
    }
  },
  methods: {
    init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug('route1:', this.$route, this.$route.query, this.currGroup)
      if (this.$route.query) {
        const { id: posterId } = this.$route.query
        this.curr_analysisTypeItem.posterId = posterId
      }
      this.getPosterDetail()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    themeItemRenderDataEventHandler(childData) {
      // 获取主题中的数据 renderData
      this.themeItemData = childData.themeItem
    },
    changeDesignStyle(curStyleId) {
      console.debug(curStyleId)
      this.currArr_designStyles.forEach((styleItem) => {
        if (curStyleId === styleItem.id) {
          this.currArr_picSizeArr = styleItem.picSizeArr
        }
      })
    },
    editMatchOpt(item) {
      if (item.id === 'schedule') {
        this.isdDrawerOpen_schedule = true
        console.debug('allMatchList:', this.currItem_params, this.allMatchList)
        // if(this){
        //   this.getScheduleMatchList('init')
        // }
      } else if (item.id === 'competition') {
        this.isdDrawerOpen_competition = true
      }
    },
    async changeMatchItemEventHandler(data) {
      // 比赛发生变化回调
      console.debug('changeMatchItemEventHandler:', data)
      const matchItem = data.data
      this.currArr_editListWeb.forEach((editItem) => {
        if (editItem.id === 'schedule') {
          const nameArr = [
            `${matchItem.formatDate} ${matchItem.formatTime}`,
            `${matchItem.sportsName}·${matchItem.scheduleName}`,
          ]
          if (matchItem.type === this.sportsTypeArr[0]) {
            // 如果是对抗类比赛 加上对阵信息
            if (matchItem.competitorType === 'T') {
              nameArr.push(`${matchItem.homeName} vs ${matchItem.awayName}`)
            }
          }
          const valueArr = [
            matchItem.sportsId,
            matchItem.eventId,
            matchItem.matchId,
            matchItem.startDatetimeUtc.split('T'),
          ]
          editItem.editArr = [
            {
              nameArr,
              valueArr,
            },
          ]
        }
      })
      // 加载主题
      if (['init', 'actMatch'].includes(data.type)) {
        await this.getPosterfindAnalysisItemById(
          this.currItem_params.posterAnalysis.analysisItemId,
          matchItem.matchId,
          this.curr_analysisTypeItem.posterId
        )
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', false) //修改赛事|赛季 和 大小项|日 和 修改比赛都会这里
    },
    closeDoneEventHandler(data) {
      // 比赛弹窗关闭动画结束回调
      if (data.type === 'cidSid') {
        this.isdDrawerOpen_competition = false
      } else if (data.type === 'didEid') {
        this.isdDrawerOpen_schedule = false
      }
    },
    saveParamsEventHandler(data) {
      // 用户修改后赛事和赛季，重新读取数据
      this.currItem_params.competitionId = data.data[0]
      this.currItem_params.seasonId = data.data[1]
      let actCompetitionIndex = 0
      let actSeasonIndex = 0
      this.currArr_competitions.forEach((competitionItem, competitionIndex) => {
        console.debug('competitionItem:', competitionItem)
        if (data.data[0] === competitionItem.competitionId) {
          this.currArr_seasons = competitionItem.seasons
          actCompetitionIndex = competitionIndex
        }
      })
      console.debug(
        'competitionItem:',
        actCompetitionIndex,
        this.currArr_seasons
      )
      this.currArr_seasons.forEach((seasonItem, seasonIndex) => {
        if (data.data[1] === seasonItem.seasonId) {
          actSeasonIndex = seasonIndex
        }
      })
      this.initCompetitionOpt(actCompetitionIndex, actSeasonIndex)
    },
    changeSelectItemEventHandler(data) {
      const { type, value, posterAnalysis } = data
      console.debug('changeSelectItemEventHandler:', data)
      if (type === 'bigSports') {
        // let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
        this.currItem_params.sportsId = value[0]
        this.currItem_params.eventId = value[1]
        this.currArr_sports.forEach((sportItem, sportsIndex) => {
          if (sportItem.value === value) {
            this.currArr_events = sportItem.events
            this.selectOptData.configArr[0].selectIndex = sportsIndex
            this.selectOptData.configArr[1].selectIndex = 0 //小项 默认第一个
            this.selectOptData.configArr[2].selectIndex = 0 //日期 默认第一个
          }
        })
      } else if (type === 'sportEvents') {
        this.currItem_params.sportsId = value[0]
        this.currItem_params.eventId = value[1]
        this.currArr_events.forEach((eventItem, eventIndex) => {
          if (eventItem.value === value) {
            this.selectOptData.configArr[1].selectIndex = eventIndex
            this.selectOptData.configArr[2].selectIndex = 0 //日期 默认第一个
          }
        })
      }
      if (['bigSports', 'sportEvents'].includes(type)) {
        window.mixtmtBase_eventBus.$emit('loadingEvent', true)
        // 更换分析项id
        this.currItem_params.posterAnalysis = posterAnalysis
        this.getScheduleMatchList('selecChange')
        window.mixtmtBase_eventBus.$emit('loadingEvent', false)
      }
    },
    // localDownloadPic() {
    //   // 下载图片到本地
    //   if (this.currPicSize && this.currPicSize.length === 2) {
    //     // 清空画面多余的效果
    //     this.fileList.forEach((fileItem) => {
    //       fileItem.isDraggable = false
    //       fileItem.actState = ''
    //     })
    //     this.$nextTick(() => {
    //       html2canvas(this.$refs.workspace_view, {
    //         // width: this.currPicSize[0],
    //         // height: this.currPicSize[1],
    //         // windowWidth: this.$refs.workspace_view.scrollWidth, //开启这个生产的图片会变形
    //         // windowHeight: this.$refs.workspace_view.scrollHeight,
    //       }).then((canvas) => {
    //         // 默认返回的图片尺寸: 设置的宽高*浏览器设备像素比率
    //         const width = canvas.width
    //         const height = canvas.height
    //         const newWidth = this.currPicSize[0] // 新的宽度
    //         const newHeight = this.currPicSize[1] // 根据等比例缩放的新高度

    //         // 创建一个新的canvas来绘制新尺寸的图片
    //         const newCanvas = document.createElement('canvas')
    //         newCanvas.width = newWidth
    //         newCanvas.height = newHeight
    //         const ctx = newCanvas.getContext('2d')
    //         ctx.drawImage(canvas, 0, 0, newWidth, newHeight)
    //         this.makeBase64 = newCanvas.toDataURL('image/png')

    //         console.debug(this.makeBase64)
    //       })
    //     })
    //   }
    // },
    // draggableToPicItemChangeEvent(event, state, styleItem) {
    //   // 正常流程是：先走click选中元素,然后longPress开启元素的拖拽事件，最后drogOver结束拖拽改变元素样式
    //   let classNameArr = []
    //   let flag = false
    //   if (event) {
    //     // click|longPress 都会传 event 事件
    //     let touchTarget = event.target
    //     // 使用closest方法查找最近的匹配的父级元素
    //     const parentElement = touchTarget.closest('.picContainer')
    //     if (parentElement) {
    //       classNameArr = parentElement.className.split(' ')
    //     }
    //   }
    //   console.debug('draggableToPicItemChangeEvent:', event, classNameArr)
    //   this.fileList.forEach((fileItem) => {
    //     if (
    //       event &&
    //       classNameArr.length > 0 &&
    //       classNameArr.includes(fileItem.className)
    //     ) {
    //       // 只有长按时，event才有值，其他情况都是null，这种情况是：
    //       // state = click 时，刚刚点击时，拖拽属性依然关闭
    //       // state = longPress 时，开启元素拖拽
    //       if (state === 'longPress') {
    //         flag = true
    //       }
    //       fileItem.isDraggable = flag
    //       fileItem.actState = state
    //       this.curPicItem = fileItem
    //     } else {
    //       if (
    //         this.curPicItem &&
    //         this.curPicItem.className === fileItem.className
    //       ) {
    //         if (styleItem) {
    //           // 拖动结束加样式
    //           fileItem.styleItem = styleItem
    //         }
    //         if (['click', 'drogOver'].includes(state)) {
    //           flag = false
    //           console.debug('draggableToPicItemChangeEvent:', fileItem)
    //           if (fileItem.isDraggable) {
    //             // 启动拖拽之后，此时只能是 drogOver，拖拽结束，保留选中样式
    //             fileItem.actState = 'click'
    //           } else {
    //             // 只能是click: 如果是drogOver，此时isDraggable比为true
    //             fileItem.actState = 'click'
    //           }
    //           fileItem.isDraggable = flag
    //         }
    //       } else {
    //         fileItem.isDraggable = false
    //       }
    //     }
    //   })
    //   // if (!flag && state === 'drogOver') {
    //   //   // 单独点击时不需要清空，需要保留；所以只有拖拽过的才会清空
    //   //   this.curPicItem = null
    //   // }
    //   console.debug('draggableToPicItemChangeEvent:', state, this.fileList)
    // },
    // async dialogCancelEventHandler(val) {
    //   // 弹窗中【取消|关闭弹窗】按钮，不是分享按钮中的取消创建主题
    //   // console.debug('dialogCancelEventHandler:', this.themeItem, val)
    //   this.dialogItem = null
    // },

    // clickInputFileEventHandler(data) {
    //   if (!this.uploadDom) {
    //     this.uploadDom = document.getElementById(this.uploadDom_id)
    //     this.uploadDom.click()
    //     this.curUploadFileItem = data.item
    //   }
    // },
    // loadFileEvent(event) {
    //   console.debug(event)
    //   if (!this.uploadDom) {
    //     this.uploadDom = document.getElementById(this.uploadDom_id)
    //   }
    //   const file = this.uploadDom.files[0]
    //   this.uploadDom.value = ''
    //   this.packageFileList(file)
    // },

    // guid(format) {
    //   // 'm-upload-file-xxxxxx-4xxx-yxxx'
    //   return format.replace(/[x,y]/g, function (c) {
    //     let r = (Math.random() * 16) | 0,
    //       v = c == 'x' ? r : (r & 0x3) | 0x8
    //     return v.toString(16)
    //   })
    // },

    // computFileName(fileName) {
    //   console.debug(fileName)
    //   const fileNameArr = fileName.split('?')
    //   return fileNameArr[0]
    // },
    // closeCropperHandler() {
    //   // 关闭图片裁切弹窗
    //   this.clickUploadBtn(true)
    // },
    // uploadHanlder(imageDataObj) {
    //   // 保存裁切图片的回调
    //   console.debug(
    //     'uploadHanlder:',
    //     imageDataObj,
    //     this.fileList,
    //     this.editFile
    //   )

    //   let dataFile = this.dataURLtoFile(imageDataObj, this.editFile.name)
    //   if (this.fileList && this.fileList.length > 0) {
    //     this.fileList.forEach((item) => {
    //       if (item.uid === this.editFile.uid) {
    //         item.url = imageDataObj
    //         // item.percentage = 20
    //         // item.status = 'progress'
    //         item.size = dataFile.size
    //         item.raw = dataFile
    //       }
    //     })
    //   }

    //   this.closeCropperHandler()
    //   //   console.debug(dataFile)
    //   // this.uploadToOss(dataFile)
    // },
    // dataURLtoFile(dataurl, filename) {
    //   var arr = dataurl.split(this.jionUrlSymbols),
    //     mime = arr[0].match(/:(.*?);/)[1],
    //     bstr = window.atob(arr[1]),
    //     n = bstr.length,
    //     u8arr = new Uint8Array(n)
    //   while (n--) {
    //     u8arr[n] = bstr.charCodeAt(n)
    //   }
    //   return new File([u8arr], filename, { type: mime })
    // },
    // clickUploadBtn(flag) {
    //   this.showCropperPop = !flag
    // },
    // async uploadToOss(data) {
    //   // const query = this.$route.query
    //   let params = null
    //   let pathUrl = null
    //   await https_getOssUploadInfor(this.axiosBaseUrl, this.$axios)
    //     .then((response) => {
    //       const res = response.data
    //       console.debug('https_getOssUploadInfor:', res)
    //       // 上传到oss
    //       params = {
    //         // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
    //         region: 'oss-cn-beijing',
    //         // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
    //         accessKeyId: res.data.accessKeyId, //'STS.NTGB8nQVfw2FgqhHiTCp2YnBU',
    //         accessKeySecret: res.data.accessKeySecret, //'DtvoZfCR7kyEs1eg8dyzzmXEeNCbFHbnEJUmFxJmCgXP',
    //         // 从STS服务获取的安全令牌（SecurityToken）。
    //         stsToken: res.data.securityToken,
    //         // 填写Bucket名称。
    //         bucket: res.data.bucketName,
    //       }
    //       if (res.data.folder && res.data.bucketName) {
    //         let type = this.editFile.name.split('.')[1]
    //         let name = this.guid('m-platfrom-upload-file-xxxxxx-vxxx-4xxx')
    //         pathUrl = `${res.data.folder}/${name}.${type}`
    //       }
    //     })
    //     .catch((err) => {
    //       console.debug(err)
    //     })
    //   if (params && pathUrl) {
    //     await ossPutObject(
    //       params,
    //       data,
    //       pathUrl,
    //       this.uploadOssSuccess,
    //       this.uploadOssErr
    //     )
    //     // 上传完之后关闭弹窗
    //     this.closeCropperHandler()
    //   }
    // },
    // uploadOssSuccess(data, pathUrl, signUrl) {
    //   console.debug('uploadOssSuccess:', data, pathUrl, signUrl)
    //   if (this.fileList && this.fileList.length > 0) {
    //     this.fileList.forEach((item) => {
    //       if (item.uid === this.editFile.uid) {
    //         item.submitVal = pathUrl //后端只要不含oss域名路径的地址路径
    //         item.percentage = 100
    //         item.status = 'success'
    //         item.ossUrl = signUrl //oss生产的线上路径并且带签名
    //       }
    //     })
    //   }
    //   console.debug('this.fileList:', this.fileList)
    //   if (this.fileList && this.fileList.length === 1) {
    //     this.$emit('submitImageEvent', {
    //       absOssUrl: pathUrl,
    //       fullOssUrl: signUrl,
    //       uploadFileItem: this.item,
    //     })
    //   }
    //   if (this.fileList && this.fileList.length > 1) {
    //     let absUrlArr = [],
    //       fullUrlArr = []
    //     this.fileList.forEach((item) => {
    //       absUrlArr.push(item.submitVal)
    //       fullUrlArr.push(item.ossUrl)
    //     })
    //     this.$emit('submitImageEvent', {
    //       fullOssUrl: fullUrlArr.join(this.jionUrlSymbols),
    //       absOssUrl: absUrlArr.join(this.jionUrlSymbols),
    //       uploadFileItem: this.item,
    //     })
    //   }
    // },
    // uploadOssErr(err) {
    //   console.debug('uploadOssErr:', err)
    // },
    // handleRemove(uploadFile, uploadFiles) {
    //   console.debug('handleRemove:', uploadFile, uploadFiles)
    // },
    // loactionPreviewEventHandler(data) {
    //   // 将图片上传到oss服务器，
    //   // 抠图需要这个逻辑，将图片上传，服务区去抠图，然后将扣完的图吐给前端展示
    //   const { data: file } = data
    //   console.debug('loactionPreview:', file)
    //   if (this.customUploadCallback) {
    //     this.customUploadCallback(file)
    //   } else {
    //     let newFile = JSON.parse(JSON.stringify(file))
    //     newFile.name = this.computFileName(file.name)
    //     this.editFile = newFile
    //     if (this.fileList && this.fileList.length > 0) {
    //       this.fileList.forEach((item) => {
    //         if (item.uid === this.editFile.uid) {
    //           item.percentage = 40
    //           item.status = 'progress'
    //         }
    //       })
    //     }
    //     this.uploadToOss(file.raw)
    //   }
    // },
    // async packageFileList(file) {
    //   // 将图片文件包装成 fileList 能使用的元素
    //   console.debug(file)
    //   const url = await this.fileToBase64Async(file)
    //   this.curUploadFileItem
    //   this.fileList = this.fileList.map((fileItem) => {
    //     console.debug(
    //       this.curUploadFileItem,
    //       fileItem.uid === this.curUploadFileItem.uid
    //     )
    //     if (fileItem.uid === this.curUploadFileItem.uid) {
    //       return {
    //         // 字段需要最后完善
    //         name: file.name,
    //         percentage: 0,
    //         status: 'location',
    //         size: file.size,
    //         raw: file,
    //         uid: this.guid('image-xxxx-xxxx-xxxx'),
    //         url,
    //         submitVal: '',
    //         absOssUrl: '',
    //       }
    //     } else {
    //       return fileItem
    //     }
    //   })
    //   console.debug(this.fileList)
    // },
    // async fileToBase64Async(file) {
    //   // param {File} file
    //   return new Promise((resolve) => {
    //     let reader = new FileReader()
    //     reader.readAsDataURL(file)
    //     reader.onload = (e) => {
    //       resolve(e.target.result)
    //     }
    //   })
    // },
    // cropPreviewEventHandler(data) {
    //   // 将需要裁切的图片对象赋值给裁切组件，给 editFile 赋值
    //   const { data: file } = data
    //   console.debug('cropPreview:', file)
    //   let newFile = JSON.parse(JSON.stringify(file))
    //   newFile.name = this.computFileName(file.name)
    //   this.editFile = newFile
    //   this.showCropperPop = true
    // },
    async getPosterfindAnalysisItemById(analysisId, matchId, posterId) {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      let params = {
        analysisId,
        matchId,
        posterId,
      }
      await https_dataPoster_findAnalysisItemById(
        this.currItem_params.urlPrefix,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          let { num } = this.paramsChangeObj
          if (res.status === 0) {
            console.debug(res.data)
            // 设置 设计风格 list
            this.findAnalysisItemResData = res.data ? res.data : []
            if (this.findAnalysisItemResData) {
              const themeItem = this.findAnalysisItemResData[0]
              this.findAnalysisItemParams = {
                sportType: this.currItem_params.sportType,
                cid: themeItem.competitionId,
                sid: themeItem.seasonId,
                did: themeItem.disciplineId ? themeItem.disciplineId : 0,
                eid: themeItem.eventId ? themeItem.eventId : 0,
                pid: themeItem.phaseId ? themeItem.phaseId : 0,
                mid: matchId ? matchId : 0,
              }
              this.currArr_designStyles = themeItem.posterAnalysisStyles.map(
                (item) => {
                  return {
                    id: item.styleId,
                    name: item.styleName,
                    picSizeArr: item.styleResolutions.map((sizeItem) => {
                      sizeItem.id = sizeItem.resolutionId
                      sizeItem.name = sizeItem.resolutionName
                      // sizeItem.posterBgImageUrl =
                      //   sizeItem.defaultResolutionPicture
                      // sizeItem.posterBgImageUrlBase64 =
                      //   sizeItem.defaultResolutionPictureBase64
                      return sizeItem
                    }),
                  }
                }
              )
              this.currItem_params.designStyleId =
                this.currArr_designStyles[0].id
              this.currArr_picSizeArr = this.currArr_designStyles[0].picSizeArr
              // this.currItem_workspaceParams = {
              //   curSizeId: this.currArr_picSizeArr[0].id,
              // }

              this.paramsChangeObj = {
                type: 'reset',
                num: num + 1,
              }
            } else {
              this.findAnalysisItemParams = null
              this.paramsChangeObj = {
                type: 'clear',
                num: num + 1,
              }
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getPosterDetail() {
      let params = {
        posterId: this.curr_analysisTypeItem.posterId,
      }
      await https_dataPoster_posterDetail(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            console.debug(res.data)
            this.usePosterOpt = res.data.userSelect
              ? res.data.userSelect[0]
              : null
            this.analysisTypesList_org = res.data.posters.map(
              (analysisTypeItem) => {
                if (analysisTypeItem.analysisTypes) {
                  analysisTypeItem.analysisTypes.forEach((item, index) => {
                    item.id = item.analysisTypeId + ''
                    item.name = item.analysisTypeName + ''
                  })
                }
                return analysisTypeItem
              }
            )
            this.curr_analysisTypeItem =
              this.analysisTypesList_org &&
              this.analysisTypesList_org.length > 0
                ? JSON.parse(JSON.stringify(this.analysisTypesList_org[0]))
                : null // 数组有值则默认只取第一个，没有就是null

            this.initPosterInfor(null, 'init')
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    initPosterInfor(actIndexArr, state) {
      console.debug('initPosterInfor')
      let indexArr = [0, 0] //主题索引，赛事索引，赛季索引
      if (actIndexArr) {
        indexArr = actIndexArr
      }
      if (this.curr_analysisTypeItem) {
        this.currArr_analysisTypes = this.curr_analysisTypeItem.analysisTypes
        console.debug(
          'initPosterInfor this.currArr_analysisTypes:',
          this.curr_analysisTypeItem
        )
        this.posterBaseInfor = {
          posterName: this.curr_analysisTypeItem.posterName,
          posterId: this.curr_analysisTypeItem.posterId,
          curr_posterAnalysisObj: null, //暂时还没有做切换设计风格，数据联动
        }

        // 根据用户自己的海报配置，默认初始化第一个海报的赛事和赛季；如果没有对应则默认取[0,0]
        if (this.usePosterOpt && state === 'init') {
          this.currArr_analysisTypes[0].competitions.forEach(
            (cItem, cIndex) => {
              if (cItem.competitionId === this.usePosterOpt.competitionId) {
                indexArr[0] = cIndex
                cItem.seasons.forEach((sItem, sIndex) => {
                  if (sItem.seasonId === this.usePosterOpt.seasonId) {
                    indexArr[1] = sIndex
                  }
                })
              }
            }
          )
        }
        console.debug('indexArr:', indexArr)
        this.currArr_analysisTypes.forEach(
          (analysisTypeItem, analysisTypeItemIndex) => {
            if (indexArr) {
              // 默认都是第一个海报主题
              if (analysisTypeItemIndex === 0) {
                this.currItem_params.analysisTypeId = analysisTypeItem.id
                this.currArr_competitions = analysisTypeItem.competitions
                this.initCompetitionOpt(indexArr[0], indexArr[1])
              }
            }
          }
        )
      }
    },
    initCompetitionOpt(index, seasonIndx) {
      console.debug('initCompetitionOpt')
      if (this.currArr_competitions) {
        this.currArr_competitions.forEach(
          (competitionItem, competitionItemIndex) => {
            if (competitionItemIndex === index) {
              this.currItem_params.competitionId = competitionItem.competitionId
              this.currArr_seasons = competitionItem.seasons
                ? competitionItem.seasons
                : []
              this.currItem_params.sportType = competitionItem.sportType
              this.currItem_params.urlPrefix = `/${competitionItem.urlPrefix}`
              this.currArr_editListWeb.forEach((editItem) => {
                if (editItem.id === 'competition') {
                  editItem.editArr.forEach((item) => {
                    if (item.valueArr.includes('competitionId')) {
                      item.nameArr = [competitionItem.competitionName]
                    }
                  })
                }
              })
              this.initSeasonOpt(seasonIndx ? seasonIndx : 0)
            }
          }
        )
      }
    },
    initSeasonOpt(index) {
      console.debug('initSeasonOpt')
      if (this.currArr_competitions) {
        this.currArr_seasons.forEach((seasonItem, seasonItemIndex) => {
          if (seasonItemIndex === index) {
            this.currItem_params.seasonId = seasonItem.seasonId
            this.currArr_editListWeb.forEach((editItem) => {
              if (editItem.id === 'competition') {
                editItem.editArr.forEach((item) => {
                  if (item.valueArr.includes('seasonId')) {
                    item.nameArr = [seasonItem.seasonName]
                  }
                })
              }
            })
            if (this.currItem_params.sportType === 'compreSportsMeet') {
              this.currArr_sports = seasonItem.disciplines
                ? seasonItem.disciplines.map((item) => {
                    item.value = item.disciplineId
                    item.name = item.disciplineName
                    item.events.forEach((eventItem) => {
                      eventItem.name = eventItem.eventName
                      eventItem.value = eventItem.eventId
                    })
                    return item
                  })
                : []

              this.initSportsOpt(0) //大项默认都是第一个
            }
          }
        })
      }
    },
    initSportsOpt(index) {
      console.debug('initSportsOpt:', this.currItem_params, this.currArr_sports)
      if (this.currArr_sports) {
        this.currArr_sports.forEach((sportsItem, sportsItemIndex) => {
          if (sportsItemIndex === index) {
            this.currItem_params.sportsId = sportsItem.disciplineId
            if (this.currItem_params.sportType === 'compreSportsMeet') {
              this.currArr_events = sportsItem.events ? sportsItem.events : []
              this.initEventOpt(index)
            }
          }
        })
      }
    },
    initEventOpt(index) {
      console.debug('initEventOpt')
      if (this.currArr_events) {
        this.currArr_events.forEach((eventItem, eventItemIndex) => {
          if (eventItemIndex === index) {
            this.currItem_params.eventId = eventItem.eventId
            this.currItem_params.posterAnalysis = eventItem.posterAnalysis
            this.getScheduleMatchList('init')
          }
        })
      }
    },
    async getScheduleMatchList(state) {
      await https_sportsEvent_schedule(
        this.currItem_params.urlPrefix,
        this.$axios,
        {
          sid: this.currItem_params.seasonId,
          sportsId: this.currItem_params.sportsId
            ? this.currItem_params.sportsId
            : '',
          eventId: this.currItem_params.eventId
            ? this.currItem_params.eventId
            : '',
          timeZone: 'beijing', // 'beijing',
        }
      )
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              // this.allMatchList = allMatchList.data
              this.allMatchList = this.computedMatchList(res.data)
              this.changeMatchItemEventHandler({
                type: state, //[init:初始化页面时加载主题信息；selecChange:弹窗中的选择框变化，不加载主题信息，只加载更换比赛；actMatch:选中比赛时加载主题信息]
                data: this.allMatchList[0],
              })
            } else {
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    computedMatchList(list) {
      let allMatchList = []
      if (list && list.length > 0) {
        list.forEach((item) => {
          let newItem = {}
          newItem.matchTime = item.formatTime
          newItem.matchName = `${item.disciplineName}·${item.scheduleName}`
          newItem.isChina = item.cn
          newItem.isGold = item.medalFlag === '1'
          newItem.competitorType = item.competitorType
          newItem.type = item.confrontation
            ? this.sportsTypeArr[0]
            : this.sportsTypeArr[1]
          newItem.matchId = item.scheduleCode
          newItem.chooseId = item.scheduleCode
          newItem.venueName = item.venueName
          newItem.matchStatus = item.scheduleStatus
          newItem.sportsId = item.disciplineCode
          newItem.sportsName = item.disciplineName
          newItem.eventId = item.eventCode
          newItem.eventName = item.eventName
          newItem.scheduleName = item.scheduleName
          newItem.formatDate = item.formatDate
          newItem.formatTime = item.formatTime
          newItem.startDatetimeUtc = item.startDatetimeUtc
          newItem.isChooseFlag = false
          newItem.competitorType = item.competitorType
          newItem.medalist = item.medals
            ? item.medals.map((player, index) => {
                return {
                  playerId: index + 1,
                  mcompetitorType: player.mcompetitorType,
                  playerName: player.competitorName,
                  medalType: player.medalType,
                  delegationName: player.organisationName,
                  delegationLogo: player.organisationLogo,
                }
              })
            : []

          if (newItem.type === this.sportsTypeArr[0]) {
            let homeName = '',
              awayName = ''
            homeName = item.competitor1Name ? item.competitor1Name : '待定'
            awayName = item.competitor2Name ? item.competitor2Name : '待定'

            newItem.homeName = homeName
            newItem.awayName = awayName

            newItem.homeScore = item.competitor1Result
            newItem.awayScore = item.competitor2Result
          }
          newItem.homeLogo = item.organisation1Logo
          newItem.awayLogo = item.organisation2Logo
          allMatchList.push(newItem)
        })
        console.debug('computedMatchList end:', allMatchList)
        return allMatchList
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#dataPoster_workstation {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 2.083vw 0;
  .main_left {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    /* flex: 1; */
    width: calc(100% - 26.388vw - 1.388vw);
    border: 1px solid var(--mixtmt_greyColor8);
    .workspace_topAbs {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      position: absolute;
      right: 0.694vw;
      top: 0.694vw;
      z-index: 100;
      width: calc(100% - 1.388vw);
      height: auto;
      .picSizeSelect {
        width: 9.72vw;
      }
    }
    .workspace_bottomAbs {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      left: 0.694vw;
      bottom: 0.694vw;
      z-index: 100;
      width: calc(100% - 1.388vw);
      height: auto;
      .bottomLeft,
      .bottomRight {
        width: 50%;
        display: flex;
        display: -webkit-flex;
        align-items: center;
      }
      .bottomLeft {
        justify-content: flex-start;
      }
      .bottomRight {
        justify-content: flex-end;
      }
      .workspace_btn {
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
        width: 6.94vw;
        height: 2.083vw;
        border: 1px solid var(--mixtmt_greyColor4);
        background-color: var(--mixtmt_whiteColor);
        font-size: 0.972vw;
        color: var(--mixtmt_greyColor4);
        border-radius: 0.208vw;
      }
    }
    .workspace_main {
      position: relative;
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      background-color: var(--mixtmt_greyColor14);
      .defaultPic {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .pic_icon {
          font-size: 2.778vw;
          color: var(--mixtmt_greyColor6);
        }
        .textArea {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          font-size: 1.11vw;
          line-height: 2.083vw;
          color: var(--mixtmt_greyColor2);
          .highColor {
            color: var(--mixtmt_subColor1_1);
          }
        }
      }
      .workspace_view {
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 10;
        width: 100%;
        height: 100%;
        background-image: url('/static/compreSportsMeet/olympicGames_SOG/dataPoster/hengban1.jpg');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: left top;
        .picContainer {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          /* left: 30%;
          top: 0; */
          z-index: 20;
          overflow: hidden;
          cursor: move !important;
          &:hover {
            cursor: move !important;
          }
          &.click {
            .imageSpan {
              &::before {
                border: 1px solid var(--mixtmt_mainColor);
              }
            }
          }
          &.longPress {
            .imageSpan {
              /* opacity: 0.6; */
              &::before {
                background-color: var(--mixtmt_greyColor5);
                border: 1px solid var(--mixtmt_subColor1_1);
              }
            }
          }
          .imageSpan {
            position: relative;
            /* width: 100%;
            height: 100%; */
            width: 4.16vw;
            height: 4.16vw;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
            &::before {
              position: absolute;
              left: 0;
              top: 0;
              z-index: 2;
              content: '\20';
              pointer-events: none;
              width: 100%;
              height: 100%;
              border: 0;
            }
          }
        }
      }
    }
  }
  .main_right {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 26.388vw;
    height: auto;
    padding: 1.0416vw;
    border: 1px solid var(--mixtmt_greyColor8);
    color: var(--mixtmt_greyColor3);
    .librayTitle {
      width: 100%;
      font-size: 1.25vw;
      text-align: left;
      font-weight: bold;
      line-height: 2.2vw;
      padding-bottom: 1.0416vw;
      height: 3.2416vw;
    }
    .selectGourp {
      width: 100%;
      padding-bottom: 1.0416vw;
      .selectTitle {
        display: block;
        font-size: 1.11vw;
        line-height: 2.083vw;
        font-weight: bold;
      }
    }
    .editRow_area {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 1.0416vw;
      &.competition {
        .editBody {
          .inputBox {
            height: 2.083vw;
            width: calc(50% - 0.347vw);
          }
        }
      }
      &.schedule {
        align-items: flex-start;
        .editTitle,
        .editBtn {
          line-height: 2.083vw;
        }
        .editBody {
          .inputBox {
            width: 100%;
            height: 6.25vw;
          }
        }
      }
      .editTitle {
        width: 3vw;
        font-size: 1.11vw;
        font-weight: bold;
      }
      .editBtn {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: 2.4vw;
        height: 2.4vw;
        font-size: 1.68vw;
        color: var(--mixtmt_subColor1_1);
      }
      .editBody {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100% - 3vw - 2.4vw);
        color: var(--mixtmt_greyColor2);
        .inputBox {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          background-color: var(--mixtmt_greyColor14);
          border: 1px solid var(--mixtmt_greyColor8);
          border-radius: 0.278vw;
          .inputRowText {
            font-size: 0.974vw;
            line-height: 1.388vw;
          }
        }
      }
    }
    .themeArea {
      width: 100%;
      height: 18.75vw;
      /* background-color: #ccc; */
    }
  }
  .dialog_pop {
    position: absolute;
    left: 0;
    top: 0;
  }

  .cropperPop {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 2100;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    transform: translate(-50%, -50%);
    & > div {
      width: 100%;
    }
  }

  .editPicRowItem_list {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
}
.mixtmt_pc #dataPoster_workstation {
  .main_left {
    .workspace_bottomAbs {
      .workspace_btn {
        &:hover {
          border: 1px solid var(--mixtmt_mainColor);
          background-color: var(--mixtmt_mainColor);
          color: var(--mixtmt_whiteColor);
          cursor: pointer;
        }
      }
    }
  }
  .main_right {
    .editRow_area {
      .editBtn {
        &:hover {
          color: var(--mixtmt_mainColor);
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style lang="scss">
#dataPoster_workstation {
  .theme_select {
    .el-select {
      width: 100%;
      .el-input {
        font-size: calc(0.972vw * var(--mixtmt_mixvw));
        .el-input__inner {
          height: calc(2.083vw * var(--mixtmt_mixvw));
          padding: 0 calc(2.083vw * var(--mixtmt_mixvw)) 0
            calc(0.694vw * var(--mixtmt_mixvw));
          line-height: calc(2.083vw * var(--mixtmt_mixvw) - 2px);
          border-radius: calc(0.278vw * var(--mixtmt_mixvw));
          &:focus,
          &:active {
            border-color: var(--mixtmt_mainColor8);
          }
        }
        .el-select__caret {
          font-size: calc(0.972vw * var(--mixtmt_mixvw));
        }
        .el-input__icon {
          width: calc(0.694vw * var(--mixtmt_mixvw));
          line-height: calc(2.083vw * var(--mixtmt_mixvw));
        }
      }
      .el-select__tags {
        width: 70% !important;
        max-width: 70% !important;
        & > span {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
        }
        .el-tag--small {
          height: calc(1.86vw * var(--mixtmt_mixvw) - 2px);
          padding: 0 calc(0.416vw * var(--mixtmt_mixvw));
          line-height: calc(1.388vw * var(--mixtmt_mixvw));
          &.el-tag {
            margin: calc(0.138vw * var(--mixtmt_mixvw)) 0
              calc(0.138vw * var(--mixtmt_mixvw)) 0.35vw;
            font-size: calc(0.833vw * var(--mixtmt_mixvw));
            border-radius: calc(0.278vw * var(--mixtmt_mixvw));
          }
          .el-icon-close {
            height: calc(1.5vw * var(--mixtmt_mixvw));
            width: calc(1.5vw * var(--mixtmt_mixvw));
            font-size: calc(0.833vw * var(--mixtmt_mixvw));
            line-height: calc(1.5vw * var(--mixtmt_mixvw));
            right: calc(-0.3vw * var(--mixtmt_mixvw));
            background-color: var(--mixtmt_greyColor5);
            &:hover {
              background-color: var(--mixtmt_mainColor8);
            }
          }
        }
      }
      .el-icon-arrow-up::before {
        content: '\e79a';
      }
    }
    .el-select-dropdown__empty {
      padding: calc(1.11vw * var(--mixtmt_mixvw));
      font-size: calc(0.972vw * var(--mixtmt_mixvw));
    }
  }
}

.mixtmt_pc .theme_select {
  .el-select {
    &:hover {
      .el-input__inner,
      .el-icon-arrow-up::before {
        color: var(--mixtmt_mainColor8);
      }
      .el-input__inner {
        border-color: var(--mixtmt_mainColor8);
      }
    }
  }
}
.theme_select_popper {
  .el-select-dropdown__item {
    font-size: calc(0.972vw * var(--mixtmt_mixvw));
    padding: 0 calc(1.042vw * var(--mixtmt_mixvw));
    height: calc(2.778vw * var(--mixtmt_mixvw));
    line-height: calc(2.778vw * var(--mixtmt_mixvw));
  }
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover,
  .el-select-dropdown__item.selected {
    color: var(--mixtmt_subColor1_1);
    background-color: var(--mixtmt_subColor1_2);
  }
}
</style>
